import React, { useState } from 'react'
import wishListEmptyImage from '../wishlistEmpty.png'
import { message } from 'antd'

function Wishlist () {
  const [wishlistItems, setWishlistItems] = useState(JSON.parse(sessionStorage.getItem('wishlistItems')) || [])
  const addToCart = (product) => {
    const temp = wishlistItems.filter((item) => item.productId != product.productId)
    sessionStorage.setItem('wishlistItems', JSON.stringify(temp))
    setWishlistItems(temp)
    product.qty = 1
    if (sessionStorage.getItem('cartItems') == null) {
      sessionStorage.setItem('cartItems', JSON.stringify([product]))
    } else {
      const cartItems = JSON.parse(sessionStorage.getItem('cartItems'))
      const check = cartItems.filter((item) => item.productId == product.productId)
      if (check.length == 0) {
        sessionStorage.setItem('cartItems', JSON.stringify([...cartItems, product]))
      }
    }
    message.success('Product moved to Cart', [1])
  }
  const removeProduct = (productId) => {
    const temp = wishlistItems.filter((item) => item.productId != productId)
    if (temp.length == 0) {
      sessionStorage.removeItem('wishlistItems')
    } else {
      sessionStorage.setItem('wishlistItems', JSON.stringify(temp))
    }
    setWishlistItems(temp)
    message.success('Product Removed Successfully', [1])
  }
  return (
    <>
      <div className='container'>
        <h3 className='mt-5'>Wishlist Items</h3>
        {wishlistItems?.length == 0 ? (
          <div className='d-flex flex-column align-items-center' style={{ height: '40vh' }}>
            <img src={wishListEmptyImage} style={{ width: '300px' }} />
            <h4 className='mt-3'>Your Wishlist is Empty!</h4>
          </div>
        ) : (
          <>
            {wishlistItems?.map((product) => {
              return (
                <div className='row mt-2' style={{ boxShadow: '1px 1px 10px 1px grey', borderRadius: '5px' }} id={product.productId}>
                  <div className='col-lg-3 col-md-3 col-4 col-sm-4  d-flex flex-column justify-content-center'>
                    <img src={product.url} />
                  </div>
                  <div className='col-lg-4 col-md-4 col-5 col-sm-4   d-flex flex-column justify-content-center'>
                    <h5>{product.productName}</h5>
                  </div>
                  <div className='col-lg-3 col-md-2 col-3 col-sm-4 d-flex flex-column justify-content-center'>
                    <span className='d-flex'>
                      <i class='fas fa-dollar-sign' />{' '}
                      <h6 className='ml-1' style={{ marginTop: '-3px', fontWeight: '600' }}>
                        {product.price}
                      </h6>
                    </span>
                  </div>
                  <div className='col-lg-2 col-md-3 col-12 col-sm-12 d-flex flex-column justify-content-center'>
                    <div className='btn btn-success btn-sm' onClick={() => addToCart(product)}>
                      <i className='fa fa-shopping-bag mr-2' />Add To Cart
                    </div>
                    <div className='btn btn-danger btn-sm mt-2' onClick={() => removeProduct(product.productId)}>
                      <i className='fa fa-trash mr-2' /> Remove
                    </div>
                  </div>
                </div>
              )
            })}
          </>
        )}
      </div>
    </>
  )
}
export default Wishlist
